module.exports = __webpack_public_path__ + "assets/img/back2.f670ea1a.png";